import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_LOGOUT } from "../../action-types/actions";
import axios from "axios";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export const logout = createAsyncThunk(
	ACTIONS_LOGOUT.logout,
	async ({ access_token, refresh_token }) => {
		const axiosPrivate = await useAxiosPrivate();
	  try {
		const response = await axiosPrivate.post(
		  `${process.env.REACT_APP_API_URL}${APP_PATH.logout}`,
		  { refresh_token },
		//   {
		// 	headers: {
		// 	  Authorization: `Bearer ${access_token}`,
		// 	  'User-Refresh-Token': `${refresh_token}`,
		// 	},
		//   }
		);
		if (response.data.status_code === 200) {
			toast.success(response.data.message);
			
		}
		// console.log('response.data.status_code:', typeof response.data.status_code);
		// console.log('response:', response);
		return response.data;
	  } catch (error) {
		toast.error('Logout failed. Please try again.');
		throw error.response?.data || new Error(error.message);
	  }
	}
  );